<template>
  <v-alert :color="color" dismissible @input="onClose" :value="true">
    <span
      v-if="type === 'html'"
      v-html="message"/>
    <span v-else>{{ text }}</span>
  </v-alert>
</template>

<script>
  export default {
    props: ['text', 'color', 'type', 'message'],
    methods: {
      onClose () {
        this.$emit('dismissed')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Alert.vue?d5b32d14